import { Component, OnInit, OnDestroy } from '@angular/core';
import { Params, ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { DateUtils } from '../dateutils.service';

import * as moment from 'moment';

@Component({
    templateUrl: './week.component.html',
    styleUrls: ['./week.component.sass']
})
export class WeekComponent implements OnInit {

    date = new Date()

    private oneDay = 1000 * 60 * 60 * 24;
    private navSubs : Subscription

    public nextWeek : Date;
    public lastWeek : Date;

    constructor(public route : ActivatedRoute, public router : Router, private dateutils : DateUtils) {}

    pageTitle() {
        if (this.dateutils.isThisWeek(this.date)) {
            return "This week";
        } else {
            let monday = this.dateutils.beginningOfWeek(this.date);

            var dateStr = this.dateutils.dayName(monday) + ", " + monday.getDate() + " " + this.dateutils.shortMonthName(monday);
            if (monday.getFullYear() != new Date().getFullYear()) {
                dateStr = dateStr + " " + monday.getFullYear();
            }

            return "Week starting " + dateStr;
        }
    }

    today() {
        return ["/date", "today"];
    }

    /**
     * Returns the first day of the described week.
     * @param  {number} week Week number
     * @param  {number} year Year number
     * @return {Date}        First day of week specified by parameters.
     */
    dateFromWeekAndYear(week, year) : Date {
        return moment().day("Monday").isoWeekYear(year).isoWeek(week).toDate();
    }

    weekUrl(date : Date) {
        return this.dateutils.weekUrl(date);
    }

    setNextPrevDates() {
        this.lastWeek = moment(this.date).subtract(1, "week").toDate();
        this.nextWeek = moment(this.date).add(1, "week").toDate();
    }

    /**
     * Returns a copy of the date that points to the Monday of that week.
     * Shifts the times at midnight local time.
     */
    beginningOfWeek(date : Date) : Date {
        return this.dateutils.beginningOfWeek(date);
    }

    parseWeekParam(params : Params) {
        if (params.hasOwnProperty("week")) {
            let week = parseInt(params["week"]);
            if (params.hasOwnProperty("year")) {
                let year = parseInt(params["year"]);
                return this.dateFromWeekAndYear(week, year);
            }
            let year = new Date().getFullYear();
            return this.dateFromWeekAndYear(week, year);
        }
        return this.beginningOfWeek(new Date());
    }

    ngOnInit() {
        this.navSubs = this.route.params.map((params : Params) => {
            return this.parseWeekParam(params);
        }).subscribe(newDate => {
            this.date = newDate;
            this.setNextPrevDates();
        });
    }

    ngOnDestroy() {
        if (this.navSubs) {
            this.navSubs.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/main/week.component.ts